import React from 'react'
import Message from '../Message/Message'
import './MessageSection.scss'
import PrincipalImage from "../../../assets/aboutpage/LeadersMessage/principalImage.png"
import DirectorImage from "../../../assets/aboutpage/LeadersMessage/ellen.jpeg"
import AdministrationImage from "../../../assets/aboutpage/LeadersMessage/admin.jpg"

const MessageSection = () => {
    
    const leadersMessages = [
        {
            image:DirectorImage,
            name:"Ellen Antwiwaa Sarkodie (Mrs.)",
            position:"MANAGING DIRECTOR",
            
        },
        {
            image:PrincipalImage,
            name:"Mr. Philips Yeboah Pimpong",
            position:"HEAD OF ACADEMICS"
        },
        
        {
            image:AdministrationImage,
            name:"Mr. Eric Opoku Asare",
            position:"HR / Accounts Manager",
            color:"#000000"
            
        }
    ]
  return (
    <div id='message-section'>
        
        <div className="messages">
            {
                leadersMessages.map((leaderMessage, index) => {
                    return <Message key={index} leaderMessage={leaderMessage}/>
                })
            }
            
        </div>
    </div>
  )
}

export default MessageSection